function cov_2rqae91v7l() {
  var path = "/app/src/components/long-term-content/components/limited-time-offer-badge/limited-time-offer-badge.tsx";
  var hash = "15f7dcba9d9ec00bf038c3c80776019b4b8b2173";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/long-term-content/components/limited-time-offer-badge/limited-time-offer-badge.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 37
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 12
        },
        end: {
          line: 9,
          column: 23
        }
      },
      "2": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 19,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 37
          },
          end: {
            line: 8,
            column: 38
          }
        },
        loc: {
          start: {
            line: 8,
            column: 43
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 8
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "15f7dcba9d9ec00bf038c3c80776019b4b8b2173"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2rqae91v7l = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2rqae91v7l();
import React from 'react';
import { Icon } from 'src/components/icon';
import { Typography } from 'src/components/v2/typography';
import { useLocale } from 'src/hooks/use-locale';
import styles from './styles.css';
cov_2rqae91v7l().s[0]++;
export var LimitedTimeOfferBadge = function LimitedTimeOfferBadge() {
  cov_2rqae91v7l().f[0]++;
  var t = (cov_2rqae91v7l().s[1]++, useLocale());
  cov_2rqae91v7l().s[2]++;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.icon
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "deal"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "special2",
    className: styles.text
  }, t('limited_offer')));
};